!function (Helpers, $, undefined) {
  'use strict';

  // Append .background-image-holder <img>'s as CSS backgrounds
  var initBackgroundImages = function () {
    $('.background-image-holder').each(function () {
      var imgSrc = $(this).children('img').attr('src');
      $(this).css('background', 'url("' + imgSrc + '")');
      $(this).children('img').hide();
      $(this).css('background-position', 'initial');
    });

    // Fade in background images
    setTimeout(function () {
      $('.background-image-holder').each(function () {
        $(this).addClass('fadeIn');
      });
    }, 200);
  };
  
  var getUrlVars = function () {
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for (var i = 0; i < hashes.length; i++) {
      hash = hashes[i].split('=');
      vars.push(hash[0]); //to get name before =
      vars[hash[0]] = hashes[i].slice(hashes[i].indexOf('=') + 1); //to take everything after first =
    }
    return vars;
  }

  var toggleAffix = function(affixElement, scrollElement, wrapper) {
  
    var height = affixElement.outerHeight(),
        top = wrapper.offset().top;
    
    if (scrollElement.scrollTop() >= top){
        wrapper.height(height);
        affixElement.addClass("affix");
    }
    else {
        affixElement.removeClass("affix");
        wrapper.height('auto');
    }

  };

  var bindUIActions = function () {
    
    var regexp = /[\xAE]/;
    $('body :not(script,sup)').contents().filter(function() {
      return this.nodeType === 3 && (regexp.test(this.nodeValue));
    }).replaceWith(function() {
      return this.nodeValue.replace(regexp, '<sup>$&</sup>');
    });
    
    $('[data-toggle="affix"]').each(function() {
      var ele = $(this),
          wrapper = $('<div></div>');

      ele.before(wrapper);
      $(window).on('scroll resize', function() {
        toggleAffix(ele, $(this), wrapper);
      });

      // init
      toggleAffix(ele, $(window), wrapper);
    });

    if( getUrlVars()["source"] ) {
     $("#mce-SOURCE").val( getUrlVars()["source"] );
    }
    
    $('[quantity-select]').bootstrapNumber();
    
    // mobile menu slide from the left
    $('[data-toggle="slide-collapse"]').on('click', function() {
      var $navMenuCont = $($(this).data('target'));
      console.log($(this).data('target'));
      $navMenuCont.animate({'width':'toggle'}, 280);
    });
    
    // Activate dropdown on hover for main nav
    $('.navbar-nav').on('mouseenter mouseleave','.dropdown',function(e){
      var _d=$(e.target).closest('.dropdown');_d.addClass('show');
      setTimeout(function(){
        _d[_d.is(':hover')?'addClass':'removeClass']('show');
        $('[data-toggle="dropdown"]', _d).attr('aria-expanded',_d.is(':hover'));
      },300);
    });

    // Add + or - to downdown on show/hide for main nav
    $('.navbar-nav .nav-item').on('shown.bs.dropdown hidden.bs.dropdown',function(){
      var c = $(this).hasClass('show')?'-':'+';
      $(this).children('a').children('div').html(c);
    });
    $('[data-toggle="tooltip"]').tooltip()
    
  };

  Helpers.init = function () {
    initBackgroundImages();
    bindUIActions();
  };
  
}(window.Helpers = window.Helpers || {}, jQuery),
function (Blog, $, undefined) {

  var bindUIActions = function () {
    $('#FilterBy').on('change', function () {
      location.href = jQuery(this).val();
    });
    $('#SortBy').on('change', function () {
      location.href = jQuery(this).val();
    });
  };

  Blog.init = function () {
    bindUIActions();
  };

}(window.Blog = window.Blog || {}, jQuery),
function (Collections, $, undefined) {

  var bindUIActions = function () {
    $('#FilterBy').on('change', function () {
      location.href = jQuery(this).val();
    });
    $('#SortBy').on('change', function () {
      location.href = jQuery(this).val();
    });
  };

  Collections.init = function () {
    bindUIActions();
  };

}(window.Collections = window.Collections || {}, jQuery),
// function (ProductPage, $, undefined) {

//   ProductPage.product = false;
//   ProductPage.variants = false;
//   ProductPage.current_variant = false;

//   var changeVariant = function () {
//     var variant = ProductPage.current_variant;
//     var productPrice = variant.price;
//     var originalPrice = variant.compare_at_price;
    
//     // set proper format and update price UI
//     $('[product-price]').html( Shopify.formatMoney(productPrice) );
//     $('[variant-title]').html( variant.title );
	
//     // If variant is on sale, update sale pricing UI
//     if ( productPrice < originalPrice ) {
//       $('[original-price]').html( Shopify.formatMoney(originalPrice) );
//       $('[original-price], .badge-sale').removeClass('d-none');
//     } else {
//       $('[original-price], .badge-sale').addClass('d-none');
//     }
    
//     // update UI items
//     updatePrice(); // Updates display price and sale display
//     updateImage(); // Selects the assigend image in the carousel
//     updateHistoryState(); // Adds Variant ID to URL for deeplinking
    
//   };
  
//   var updatePrice = function () {
//     var productPrice = ProductPage.current_variant.price;
//     var originalPrice = ProductPage.current_variant.compare_at_price;
    
//     // set proper format and update price UI
//     $('[product-price]').html( Shopify.formatMoney(productPrice, theme.moneyFormat) );
	
//     // If variant is on sale, update sale pricing UI
//     if ( productPrice < originalPrice ) {
//       $('[original-price]').html( Shopify.formatMoney(originalPrice, theme.moneyFormat) );
//       $('[original-price], .badge-sale').removeClass('d-none');
//     } else {
//       $('[original-price], .badge-sale').addClass('d-none');
//     }
    
//   };

//   var updateImage = function () {
//     console.log(ProductPage.current_variant)
//     $('.variant-carousels').removeClass('d-block').addClass('d-none')
//     $(`#variant-carousel-${ProductPage.current_variant.title}`).removeClass('d-none').addClass('d-block')
//     $(`#variant-carousel-${ProductPage.current_variant.title}`).flickity('resize');
//     console.log(`#variant-carousel-${ProductPage.current_variant.title}`)
    
//     return;
//     var index = ProductPage.current_variant.featured_image.position -1; // will give you 2
//     var mipSlider = $('.mip-slider').data('flexslider');
//     mipSlider.flexslider(index); // will take you to that slide
//   };
  
//   var updateHistoryState = function () {
//     // Update history state for product deeplinking
//     var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + ProductPage.current_variant.id;
//     window.history.replaceState({path: newurl}, '', newurl);
//   };
 
//   var getProductOptions = function () {
//     var currentOptions = jQuery.map($('[single-product-selector]'), function(element) {
//       var $element = $(element);
//       var type = $element.attr('type');
//       var currentOption = {};

//       if (type === 'radio' || type === 'checkbox') {
//         if ($element[0].checked) {
//           currentOption.value = $element.val();
//           currentOption.index = $element.data('index');

//           return currentOption;
//         } else {
//           return false;
//         }
//       } else {
//         currentOption.value = $element.val();
//         currentOption.index = $element.data('index');

//         return currentOption;
//       }
//     });

//     // remove any unchecked input values if using radio buttons or checkboxes
//     currentOptions = _.compact(currentOptions);

//     return currentOptions;
//   };

//   var getCurrentVariant = function ( variantId ) {
//     var variants = ProductPage.product.variants;
// 	// map variants and return the selected one
    
//     var found = jQuery.map(variants, function(variant) {
//       if(variant.id == variantId) {
//         return variant; // return matching variant object
//       }
//     });

//     return found[0]; // returns single array so pull out first element object
//   };
  
//   var bindUIActions = function () {
	
//     // Variant change
//     $('[variant-select]').on('change', function () {
//       // set current selected variant
//       ProductPage.current_variant = getCurrentVariant( this.value );
//       changeVariant();
//     });
    
//     $('.swatch :radio').on('change', function () {
//       var optionIndex = $(this).closest('.swatch').attr('data-option-index');
//       var optionValue = $(this).val();
//       ProductPage.current_variant = getCurrentVariant( optionValue );
//       $('.swatch-element.selected').removeClass('selected');
//       $(this).closest('.swatch-element').addClass('selected');

//       $('[variant-select]').eq(optionIndex).val(optionValue).trigger('change');
//       changeVariant();

//     });


//   };

//   ProductPage.init = function () {
    
//     // Get Product JSON data
//     ProductPage.product = JSON.parse(document.getElementById('ProductJson').innerHTML);
// 	//ProductPage.productOptions = getProductOptions();

//     bindUIActions();
//   }; 

// }(window.ProductPage = window.ProductPage || {}, jQuery),
function (ProductPage, $, undefined) {

  ProductPage.product = false;
  ProductPage.variants = false;
  ProductPage.current_variant = false;

  var changeVariant = function () {
    var variant = ProductPage.current_variant;
//     var productPrice = variant.price;
//     var originalPrice = variant.compare_at_price;
    
//     // set proper format and update price UI
//     $('[product-price]').html( Shopify.formatMoney(productPrice) );
//     $('[variant-title]').html( variant.title );
	
//     // If variant is on sale, update sale pricing UI
//     if ( productPrice < originalPrice ) {
//       $('[original-price]').html( Shopify.formatMoney(originalPrice) );
//       $('[original-price], .badge-sale').removeClass('d-none');
//     } else {
//       $('[original-price], .badge-sale').addClass('d-none');
//     }
    
    // update UI items
    updatePrice(); // Updates display price and sale display
    updateImage(); // Selects the assigend image in the carousel
    updateHistoryState(); // Adds Variant ID to URL for deeplinking
    
  };
  
  var updatePrice = function () {
    console.log('looking for variants',ProductPage)
    var quantity = $('#quantity').val();
    var productPrice = ProductPage.current_variant.price;
    var originalPrice = ProductPage.current_variant.compare_at_price;
    
    console.log('quantity',quantity,productPrice,originalPrice)
    
    // set proper format and update price UI
    $('[product-price]').html( Shopify.formatMoney(productPrice * quantity, theme.moneyFormat) );
	
    // If variant is on sale, update sale pricing UI
    if ( productPrice < originalPrice ) {
      $('[original-price]').html( Shopify.formatMoney(originalPrice * quantity, theme.moneyFormat) );
      $('[original-price], .badge-sale').removeClass('d-none');
    } else {
      $('[original-price], .badge-sale').addClass('d-none');
    }
    
  };

  var updateImage = function () {
    $('.variant-carousels').removeClass('d-block').addClass('d-none')
    $(`#variant-carousel-${ProductPage.current_variant.title}`).removeClass('d-none').addClass('d-block')
    $(`#variant-carousel-${ProductPage.current_variant.title}`).flickity('resize');
    
    return;
    var index = ProductPage.current_variant.featured_image.position -1; // will give you 2
    var mipSlider = $('.mip-slider').data('flexslider');
    mipSlider.flexslider(index); // will take you to that slide
  };
  
  var updateHistoryState = function () {
    // Update history state for product deeplinking
    var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + ProductPage.current_variant.id;
    window.history.replaceState({path: newurl}, '', newurl);
  };
 
  var getProductOptions = function () {
    var currentOptions = jQuery.map($('[single-product-selector]'), function(element) {
      var $element = $(element);
      var type = $element.attr('type');
      var currentOption = {};

      if (type === 'radio' || type === 'checkbox') {
        if ($element[0].checked) {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        } else {
          return false;
        }
      } else {
        currentOption.value = $element.val();
        currentOption.index = $element.data('index');

        return currentOption;
      }
    });

    // remove any unchecked input values if using radio buttons or checkboxes
    currentOptions = _.compact(currentOptions);

    return currentOptions;
  };

  var getCurrentVariant = function ( variantId ) {
    var variants = ProductPage.product.variants;
	// map variants and return the selected one
    var found = jQuery.map(variants, function(variant) {
      if(variant.id == variantId) {
        return variant; // return matching variant object
      }
    });

    return found.length ? found[0] : variants[0];
  };
  
  var bindUIActions = function () {
    // Init a current
      ProductPage.current_variant = getCurrentVariant(0);
	
    // Variant change
    $('[variant-select]').on('change', function () {
      // set current selected variant
      ProductPage.current_variant = getCurrentVariant( this.value );
      changeVariant();
    });
    // Quantity change
    $('#quantity').on('change', function () {
      updatePrice();
    });
    
    $('.swatch :radio').on('change', function () {
      var optionIndex = $(this).closest('.swatch').attr('data-option-index');
      var optionValue = $(this).val();
      ProductPage.current_variant = getCurrentVariant( optionValue );
      $('.swatch-element.selected').removeClass('selected');
      $(this).closest('.swatch-element').addClass('selected');

      $('[variant-select]').eq(optionIndex).val(optionValue).trigger('change');
      changeVariant();

    });


  };

  ProductPage.init = function () {
    
    // Get Product JSON data
    ProductPage.product = JSON.parse(document.getElementById('ProductJson').innerHTML);
	//ProductPage.productOptions = getProductOptions();

    bindUIActions();
  }; 

}(window.ProductPage = window.ProductPage || {}, jQuery),
function (MiniCart, $, undefined) {

  MiniCart.product = false;
  MiniCart.cart = false;
  MiniCart.current_variant = false;
  MiniCart.current_variant_id = false;

  var MiniCartItemsSelector = $('[mini-cart-items]');
  var MiniCartCountSelector = $('[mini-cart-count]');
  var MiniCartPriceTotalSelector = $('[mini-cart-total-price]');
  
  var getCurrentVariant = function ( variantId ) {
    var variants = MiniCart.product.variants;
	// map variants and return the selected one
    
    var found = jQuery.map(variants, function(variant) {
      if(variant.id == variantId) {
        return variant; // return matching variant object
      }
    });

    return found[0]; // returns single array so pull out first element object
  };
  
  var AddItem = function ( variant_id, quantity ) {

    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: 'quantity=' + quantity + '&id=' + variant_id,
      dataType: 'json',
      error: function(XMLHttpRequest, textStatus) {
        console.log(XMLHttpRequest, textStatus);
      },
      complete: function(jqxhr, text) {
        UpdateMiniCart();
      }
    });

    return true; // return
  };
  
  var UpdateItem = function ( variant_id, quantity ) {

    jQuery.post('/cart/change.js', {
      id: variant_id,
      quantity: quantity
    });

    return true; // return
  };
  
  var RemoveItem = function ( variant_id ) {

    jQuery.post('/cart/change.js', {
      id: variant_id,
      quantity: 0
    });

    return true; // return
  };

  var UpdateMiniCart = function () {

    // get cart contents
    jQuery.getJSON('/cart.js', function(cart) {
      //alert('There are now ' + cart.item_count + ' items in the cart.');
      
      // Loop through items and update mini cart content
      var itemMarkup = '';
      $(cart.items).each(function () {
        
        itemMarkup += '<li class="media" id="MiniCartItem-'+ this.key +'" data-item-id="'+ this.key +'" data-variant-id="'+ this.variant_id +'">';
        itemMarkup += '<div class="media-body">';
        itemMarkup += '<div class="row">';
        itemMarkup += '<div class="col-3 text-center">';
        itemMarkup += '<a href="'+ this.url +'"><img src="'+ this.image +'" alt="'+ this.title +'" class="img-fluid" /></a>';
        itemMarkup += '</div>';
        itemMarkup += '<div class="col-9">';
        itemMarkup += '<a href="'+ this.url +'><h6 class="mb-0">'+ this.product_title +'</h6></a>';
        
        if (this.variant_title) {
          	itemMarkup += '<p class="text-muted small">';
        	$(this.variant_options).each(function () {
          		itemMarkup += '<em>'+ this +'</em><br/>';
        	});
          	itemMarkup += '</p>';
        }
                                         
        itemMarkup += '<div class="row">';
        itemMarkup += '<div class="col-7 text-muted small">'+ Shopify.formatMoney(this.price) +' x <span mini-cart-item-quantity>'+ this.quantity +'</span></div>';
        itemMarkup += '<div class="col-5 text-right text-muted small font-bold">'+ Shopify.formatMoney(this.line_price) +'</div>';
        itemMarkup += '</div>';
        
        itemMarkup += '</div></div></li>';
      });
      
      // update cart contents
      MiniCartItemsSelector.html( itemMarkup );
      
      //update subtotal
	  MiniCartPriceTotalSelector.html( Shopify.formatMoney( cart.total_price ) );
      
      // update cart count on badge and header
      MiniCartCountSelector.html( cart.item_count );

    } );
    
    // Toggle open the mini cart
    //$('.cart-mini .dropdown-menu').dropdown("toggle");

    return true; // return
  };
  
  var bindUIActions = function () {
    let variant_id = undefined;
    let quantity_to_add = 1;

    // Click Add-to-Cart on item
    $('[add-to-cart]').on('click', function () {
      // if variant ID passed, use that
      if($(this).data('variant-id')) {
        variant_id = $(this).data('variant-id');
        
        // update quantity if set
        if( $(this).data('quantity') ) quantity_to_add = $(this).data('quantity');
        
        // If it's a quick add, notify that it's been added!
        if ( $(this).html() == 'Quick Add' ) $(this).html('Added to Cart')
    
      // if product page, use ProductJson
      } else {
        // Get Product JSON data
        MiniCart.product = JSON.parse(document.getElementById('ProductJson').innerHTML);
        // set current selected variant
		MiniCart.current_variant = getCurrentVariant( this.value );
        variant_id = MiniCart.current_variant.id;
        
        // update quantity if set
        quantity_to_add = document.getElementById('Quantity').val();
      }
      
      if (!variant_id) return;
      
      AddItem( variant_id, quantity_to_add );
    });
  };

  MiniCart.init = function () {
    bindUIActions();
  }; 

}(window.MiniCart = window.MiniCart || {}, jQuery),
function (Cart, $, undefined) {
  Cart.object = false;

}(window.Cart = window.Cart || {}, jQuery);